import "./ChangePassword.scss"

import React, { useState } from "react"

import { useGlobalTranslation } from "../../../utils/hook"
import InputGroup from "../../organisms/InputGroup"

const ChangePassword = () => {
  const { tt } = useGlobalTranslation()
  const [multiplePasswordType, setMultiplePasswordType] = useState({
    oldPassword: "password",
    newPassword: "password",
  })

  return (
    <div className="change-password-wrapper">
      <div className="old-password">
        <InputGroup
          field="oldPassword"
          label={tt("old-password")}
          placeholder={tt("enter-old-password")}
          inputGroupClassName="input-on-surface"
          type={multiplePasswordType.oldPassword}
          multiplePasswordType={multiplePasswordType}
          setMultiplePasswordType={setMultiplePasswordType}
        />
      </div>
      <InputGroup
        field="newPassword"
        label={tt("new-password")}
        placeholder={tt("enter-new-password")}
        inputGroupClassName="input-on-surface"
        type={multiplePasswordType.newPassword}
        multiplePasswordType={multiplePasswordType}
        setMultiplePasswordType={setMultiplePasswordType}
      />
    </div>
  )
}

export default ChangePassword
